var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBottomRightStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 147,
    viewBox: "0 0 118 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.355 4.905C34.355 7.614 36.551 9.81 39.26 9.81C41.969 9.81 44.165 7.614 44.165 4.905C44.165 2.196 41.969 0 39.26 0C36.551 0 34.355 2.196 34.355 4.905Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.079 42.896C111.079 44.574 112.439 45.934 114.117 45.934C115.795 45.934 117.155 44.574 117.155 42.896C117.155 41.218 115.795 39.858 114.117 39.858C112.44 39.858 111.079 41.218 111.079 42.896Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.10352e-05 42.896C-6.10352e-05 44.574 1.35993 45.934 3.03793 45.934C4.71593 45.934 6.07593 44.574 6.07593 42.896C6.07593 41.218 4.71593 39.858 3.03793 39.858C1.36093 39.858 -6.10352e-05 41.218 -6.10352e-05 42.896Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8351 146.587C28.1572 146.587 26.7971 145.227 26.7971 143.549C26.7971 141.871 28.1572 140.511 29.8351 140.511C31.5129 140.511 32.873 141.871 32.873 143.549C32.873 145.227 31.5129 146.587 29.8351 146.587Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.235 120.24C91.334 125.845 86.939 130.239 81.335 131.14C86.94 132.041 91.334 136.436 92.235 142.04C93.136 136.435 97.531 132.041 103.135 131.14C97.53 130.239 93.136 125.844 92.235 120.24Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomRightStars);
export default __webpack_public_path__ + "static/media/bottom-right-stars.93c6cfe1bcde257aa09ae178a98bed2d.svg";
export { ForwardRef as ReactComponent };